import React from 'react'
import {SimpleBanner} from './banner'
import Chat from './chat'


export default class ChatPage extends React.Component {
	render() {
		const { params } = this.props.match || {};

		return (
			<div>
				<SimpleBanner title={__('socials_chat')} />
				<div className="mt-4">
					<div className="row justify-content-center no-gutters">
						<div className="col-md-8 center mb-2">
							<span>{__('socials_chat_tip')}</span>
						</div>
						<div className="col-md-8">
							<Chat to={params.uid || null} />
						</div>
					</div>
				</div>
			</div>
		)
	}
}
